/* eslint-disable import/prefer-default-export */
import { PostAttachmentInput } from '__generated__/graphql/legacy/graphql';
import { Post } from 'types/post';
import { rawId } from 'utils/rawId';

import { Attachment } from 'schema/Post/types';

export const sanitizeAttachment = (attachment: Attachment): PostAttachmentInput | null => {
  if (!attachment) return null;

  const {
    attachmentType,
    attachmentUrl,
    fileName,
    fileSizeInBytes,
    id,
    s3Bucket,
    s3Key,
    filestackId,
    altText,
  } = attachment;

  return {
    attachmentType,
    attachmentUrl,
    fileName,
    fileSizeInBytes,
    // @ts-ignore until backend is released for types
    id: id ? rawId(id) : null, // Backend expects decoded Int id, not encoded string
    s3Bucket,
    s3Key,
    filestackId,
    altText,
  };
};

export const sanitizeAttachments = (attachments: Attachment[]): PostAttachmentInput[] => {
  if (!attachments) return [];
  return attachments
    .map((attachment) => sanitizeAttachment(attachment))
    .filter(Boolean) as PostAttachmentInput[];
};

export const getTotalNumberOfReplies = (post?: Post): number => {
  if (!post) return 0;

  const { replies } = post;

  const result =
    replies?.nodes?.reduce((total, reply) => {
      return total + (reply?.replies?.totalCount || 0);
    }, replies.totalCount) || 0;

  return result || 0;
};
